import i18n from '../../VueI18n'
import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todas as medicoes de inventario cadastradas no banco de dados
 */
const getAllMedicoesInventario = async () => {
	return registryApi.get('v1/Medicao')
}

/**
 * Retorna todas as medições cadastradas no banco de dados com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca  */

const getAllMedicoesInventarioPagination = async (PagNumber, PagSize, FilteringWord) => {
	return registryApi.post('v1/Medicao/GetToCrudTable', { PagNumber, PagSize, FilteringWord })
}

/**
 * Dropdown para Medições de Inventário
 */
const getDropdownMedicoes = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Medicao/GetDropdown')

	return result.map((medicao) => {
		return {
			id: medicao.id,
			[i18n.t('code')]: `ME-${medicao.mdco_cd_codigo}`,
			[i18n.t('description')]: medicao.mdco_ds_descricao,
			[i18n.t('farm')]: `FA-${medicao.fzda_cd_codigo} - ${medicao.fzda_nm_nome}`,
			[i18n.t('forestStratification')]:
				`EF-${medicao.esfl_cd_codigo} - ${medicao.esfl_ds_descricao}`,
		}
	})
}

export const getDropdownMedicaoProcessamento = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Medicao/GetDropdownProcessamento')

	return result
}

/**
 * Dropdown de medicoes para a tela de OS de cubagem
 * @param {Id do Estrato Florestal} estratoFlorestalId
 * @returns Retorna o dropdown de medicoes
 */
const getDropdownMedicaoPorEstratoFlorestal = async (estratoFlorestalId) => {
	const {
		data: { result },
	} = await registryApi.get('v1/Medicao/GetDropdownMedicaoPorEstratoFlorestal', {
		params: { estratoFlorestalId },
	})

	return result.map((medicao) => {
		return {
			id: medicao.id,
			[i18n.t('code')]: `ME-${medicao.mdco_cd_codigo}`,
			[i18n.t('description')]: medicao.mdco_ds_descricao,
			[i18n.t('farm')]: `FA-${medicao.fzda_cd_codigo} - ${medicao.fzda_nm_nome}`,
			[i18n.t('forestStratification')]:
				`EF-${medicao.esfl_cd_codigo} - ${medicao.esfl_ds_descricao}`,
		}
	})
}

/**
 * Cadastrar nova medicao no banco de dados
 * @param {Object} body Medicao que será cadastrada
 */
const createMedicao = async (body) => {
	return registryApi.post('v1/Medicao', body)
}

/**
 * Atualiza Medicao no banco de dados
 * @param {Object} body Medicao que será atualizada
 */
const updateMedicao = async (body) => {
	return registryApi.put('v1/Medicao', body)
}

/**
 * Lista dos ids de Medicoes que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Medicao
 */
const deleteMedicaoByIdList = async (data) => {
	return registryApi.delete('v1/Medicao/DeleteByIdList', { data })
}

/**
 *  Retorna uma lista com os daps das árvores que pertencem a medição
 * que foi passada como parâmetro da função
 * @param {Guid} medicaoId Id da medição
 */
const buscarMedicaoParaPlanejarCubagem = async (medicaoId) => {
	return registryApi.get('v1/Medicao/BuscarMedicaoParaPlanejarCubagem', {
		params: { medicaoId },
	})
}

export const importMedicaoInventarioCSV = (data) => {
	return registryApi.post('v1/Medicao/ImportarCSVMedicao', data)
}

export const corrigirMedicao = (data) => {
	return registryApi.post('v1/Medicao/corrigirmedicao', data)
}

/**
 * Busca as medicoes que sejam de ordem de servico de qualidade
 */
export const medicoesDeQualidadeDropdown = () => {
	return registryApi.get('v1/medicao/get-medicoes-qualidade-dropdown')
}

export const getDadosValidacaoConsistencia = (idMedicao) => {
	return registryApi.get(
		`v2/DadosValidacaoConsistencia/recupera-informacoes-validacao-consistencia-medicao?idMedicao=${idMedicao}`,
	)
}

export {
	buscarMedicaoParaPlanejarCubagem,
	createMedicao,
	deleteMedicaoByIdList,
	getAllMedicoesInventario,
	getAllMedicoesInventarioPagination,
	getDropdownMedicaoPorEstratoFlorestal,
	getDropdownMedicoes,
	updateMedicao,
}
